/* eslint-ignore */
// @ts-nocheck
import { Field, Formik } from 'formik';
import React, { useCallback, useState, useEffect } from 'react';
import { IoMdArrowBack, IoMdArrowForward } from 'react-icons/io';
import { MdPlayArrow } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { ReactComponent as PermContactCalendar } from '~/assets/icons/perm_contact_calendar.svg';
import ContainedButton from '~/components/layout/form/containedButton';
import OutlinedButton from '~/components/layout/form/outlinedButton';
import TextField from '~/components/layout/form/textField';
import { HeaderContainer } from '../styles';
import { Container, ContainerButtons, FormContainer } from './styles';
import api from '~/services/api';

const SendEmail = ({ step, setStep, useInfo, setUseInfo }) => {
  const [loading, setLoading] = useState();

  const handleSubmit = useCallback(
    async ({ email }) => {
      setLoading(true);
      const header = {
        'Content-Type': 'application/json',
        'Accept-Language': 'pt-BR',
        Authorization: process.env.REACT_APP_SIGNIN_AUTHORIZATION,
      };
      const parameters = {
        method: 'POST',
        headers: header,
      };
      const body = {
        login: email,
        url: process.env.REACT_APP_RESET_PASSWORD_URL,
      };
      api
        .post('industrial/customer/v1/users/reset-password', body, parameters)
        .then((res) => {
          setLoading(false);
          if (res.status === 202) {
            setStep(2);
          }
        })
        .catch((err) => {
          setLoading(false);
          const erro = err.response;
          if (erro) {
            const { message } = err.response.data;
            if (err.response.status !== 401) {
              toast.error(message);
            }
          } else if (err.response.status !== 401) {
            toast.error('Ocorreu um erro interno na aplicação');
          }
        });
    },
    [toast]
  );

  const resetPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email('Insira um e-mail válido')
      .required('Preencha seu e-mail'),
  });

  return (
    <>
      <Container>
        <HeaderContainer>          
          <h1>Redefinir senha</h1>
          <h2>Infome seu e-mail de cadastro para continuar</h2>
        </HeaderContainer>
        <Formik
          initialValues={{ email: '' }}
          onSubmit={handleSubmit}
          validationSchema={resetPasswordSchema}
          render={({ handleChange, handleBlur, values, errors, touched }) => (
            <FormContainer>
              <Field
                name="email"
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Insira seu e-mail *"
                    placeholder="Insira seu e-mail *"
                    errorCondition={errors.email && touched.email}
                    errorMessage={errors.email}
                    isCorrect={!errors.email}
                    value={values.email}
                    LeadingIcon={() => <PermContactCalendar />}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                )}
              />

              <ContainerButtons>
                <ContainedButton
                  block
                  type="submit"
                  continue
                  loading={loading}
                  id="Avançar"
                  width="100%"
                  TrailingIcon={() => <IoMdArrowForward size={20} />}
                >
                  Continuar
                </ContainedButton>
                <Link to="/">
                  <OutlinedButton
                    width="100%"
                    LeadingIcon={() => <IoMdArrowBack size={20} />}
                    onClick={() => {}}
                  >
                    Voltar
                  </OutlinedButton>
                </Link>
              </ContainerButtons>
            </FormContainer>
          )}
        />
      </Container>
    </>
  );
};

export default SendEmail;
